'use client';

import Link from 'next/link';
import {Container} from '@/components/container';
import {Button} from '@/components/ui/button';

export function Footer() {
	return (
		<footer>
			<Container className="flex md:gap-8 gap-5 md:flex-row flex-col items-center justify-center py-5 border-t mt-16">
				<p className="text-muted-foreground">© Copyright {new Date().getFullYear()}. All rights reserved.</p>

				<Button variant="link">
					<Link href="/regulamin">Regulamin</Link>
				</Button>

				<Button variant="link">
					<Link href="/polityka-prywatnosci">Polityka prywatności</Link>
				</Button>
			</Container>
		</footer>
	);
}
